import { render, staticRenderFns } from "./ProductBowlPositions.vue?vue&type=template&id=fd5b83e2&"
import script from "./ProductBowlPositions.vue?vue&type=script&lang=js&"
export * from "./ProductBowlPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports